import React from 'react';
import Icon from '../../../components/AppIcon';


const AtRiskMembersList = ({ members, loading }) => {
  const getRiskColor = (score) => {
    if (score >= 75) return 'text-error';
    if (score >= 50) return 'text-warning';
    return 'text-primary';
  };

  const getRiskBadgeColor = (score) => {
    if (score >= 75) return 'bg-error/10 text-error';
    if (score >= 50) return 'bg-warning/10 text-warning';
    return 'bg-primary/10 text-primary';
  };

  if (loading) {
    return (
      <div className="card">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="card">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 rounded-lg bg-warning/10 flex items-center justify-center">
            <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
          </div>
          <div>
            <h3 className="text-xl font-heading font-semibold text-foreground">
              At-Risk Members
            </h3>
            <p className="text-sm text-muted-foreground">
              {members?.length || 0} members identified by AI analysis
            </p>
          </div>
        </div>
      </div>

      <div className="space-y-3">
        {members?.length === 0 ? (
          <div className="text-center py-8">
            <Icon name="CheckCircle" size={48} color="var(--color-success)" className="mx-auto mb-3" />
            <p className="text-muted-foreground">No at-risk members identified</p>
          </div>
        ) : (
          members?.map((member, index) => (
            <div
              key={index}
              className="bg-muted/50 rounded-lg p-4 hover:bg-muted transition-colors duration-250"
            >
              <div className="flex items-start justify-between mb-3">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                    <span className="text-sm font-semibold text-primary">
                      {member?.name?.split(' ')?.map(n => n?.[0])?.join('')}
                    </span>
                  </div>
                  <div>
                    <p className="font-medium text-foreground">{member?.name}</p>
                    <span className={`text-xs font-medium ${getRiskBadgeColor(member?.riskScore)}`}>
                      {member?.riskScore}% Risk Score
                    </span>
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <p className="text-xs font-medium text-muted-foreground mb-2">Risk Factors:</p>
                <div className="flex flex-wrap gap-2">
                  {member?.riskFactors?.map((factor, idx) => (
                    <span
                      key={idx}
                      className="text-xs px-2 py-1 rounded bg-card text-foreground"
                    >
                      {factor}
                    </span>
                  ))}
                </div>
              </div>

              <div>
                <p className="text-xs font-medium text-muted-foreground mb-2">Recommended Actions:</p>
                <ul className="space-y-1">
                  {member?.recommendedActions?.slice(0, 2)?.map((action, idx) => (
                    <li key={idx} className="flex items-start gap-2 text-xs text-muted-foreground">
                      <Icon name="CheckCircle" size={14} color="var(--color-success)" className="mt-0.5 flex-shrink-0" />
                      <span>{action}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AtRiskMembersList;